import React, { useState } from "react";
import "../../detailModal/DetailModal.css";

const ChatBoxLeftChat: React.FC<{}> = ({}) => {
  return (
    <div className="DetailModal-main-middle-view-chat-right-body-left">
      <div className="DetailModal-main-middle-view-chat-right-body-left-dp">
        <div className="DetailModal-main-middle-view-chat-right-body-left-dp-circle">
          <img src="/assets/bg/6.png" alt="" />P
        </div>
        <h5>Peter</h5>
        <h6>Customer</h6>
      </div>
      <div className="DetailModal-main-middle-view-chat-right-body-left-msg">
        <h6>Praesent consectetur ornare urna ut.</h6>
        <div
          className="d-flex"
          style={{
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <div className="DetailModal-main-middle-view-chat-right-body-left-msg-time">
            08.02.2021
          </div>
          <div className="d-flex">
            <div className="DetailModal-main-middle-view-chat-right-body-left-msg-time">
              19:35
            </div>
            <img
              src="/assets/bg/8.png"
              alt=""
              style={{ width: 15, height: 15, marginLeft: 10 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBoxLeftChat;
